import { Card, CardBody, CardFooter, Col, Row, Table } from "react-bootstrap";
import { FaBuilding } from "react-icons/fa";
import CommonUtils from "../../../../utils/common";
import { MdOutlinePayment } from "react-icons/md";
import { BsDeviceSsdFill } from "react-icons/bs";

const SummaryMask = ({data, setStep}) => {

    const UTILS = new CommonUtils();

    return (
        <>
            <Row>
                <Col xl="6">
                    <Card className="shadow-lg">
                        <CardBody>
                            <p className="text-energo"><b><FaBuilding /> Liegenschaft</b></p>
                            <Table className="equalTable" responsive="sm">
                                <tbody>
                                    <tr>
                                        <td><small className="text-muted">Name</small></td>
                                        <td>{data.building_name}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Interne Objektbezeichnung</small></td>
                                        <td>{data.bulding_ident === ""? "keine": data.bulding_ident}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Vorgang</small></td>
                                        <td>{data.vorgang}</td>
                                    </tr>
                                    {data.oldHw !== "" &&
                                        <tr>
                                            <td><small className="text-muted">Alte Hausverwaltung</small></td>
                                            <td>{data.oldHw}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <td><small className="text-muted">Land</small></td>
                                        <td>{UTILS.country_id_toStringName(data.country_id)}</td>
                                    </tr>
                                    <tr hidden={data.country_id !== "12"}>
                                        <td><small className="text-muted">Budensland</small></td>
                                        <td>{UTILS.state_id_toStringName(data.state_id)}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">PLZ</small></td>
                                        <td>{data.zip}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Ort</small></td>
                                        <td>{data.city}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Straße</small></td>
                                        <td>{data.street}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Hausnummer</small></td>
                                        <td>{data.houseNr}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Kontaktperson</small></td>
                                        <td>{data.contact.name}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("name")}} href="/ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>

                    <Card className="shadow-lg mt-3">
                        <CardBody>
                            <p className="text-energo"><b><MdOutlinePayment /> Zahlungsinformation</b></p>
                            <Table className="equalTable">
                                <tbody>
                                    <tr>
                                        <td><small className="text-muted">UID-Nummer</small></td>
                                        <td>{data.noUid? UTILS.checkUncheckIcons(false): data.uid}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Kontoinhaber</small></td>
                                        <td>{data.building_account_owner}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">IBAN</small></td>
                                        <td>{data.building_iban}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Datum Poolbeitritt</small></td>
                                        <td>{UTILS.dateToEuFormat(data.pool_start)}</td>
                                    </tr>
                                    <tr>
                                        <td><small className="text-muted">Vollmacht</small></td>
                                        {
                                            data.noVollmacht ?
                                                <td>{UTILS.checkUncheckIcons(false)}</td> :
                                            data.vollmacht.file_name !== undefined ?
                                                <td>{data.vollmacht.file_name}</td> :
                                                null
                                        }
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("abrechnung")}} href="/ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>
                </Col>
                <Col xs="12" md="12" xl="6">
                    <Card className="shadow-lg">
                        <CardBody>
                            <p className="text-energo"><b><BsDeviceSsdFill /> Anlagen</b></p>
                            <Table responsive="sm">
                                <thead>
                                    <tr>
                                        <td>#</td>
                                        <td>Energieform</td>
                                        <td>Anlagenverwendung</td>
                                        <td>Top</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.anlagen.map((anlage, i) => (
                                        <tr key={`anlage-${i}`}>
                                            <td><small>{i + 1}</small></td>
                                            <td><small>{anlage.energyForm}</small></td>
                                            <td><small>{anlage.x_anlagenverwendung}</small></td>
                                            <td><small>{anlage.top}</small></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("anlagen")}} href="/ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
export default SummaryMask;